import { render, staticRenderFns } from "./SimpleChips.vue?vue&type=template&id=59fb51bf"
import script from "./SimpleChips.vue?vue&type=script&lang=js"
export * from "./SimpleChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports